exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TabNav-16a824eb{color:#666}.Tab-82b95533{cursor:pointer;margin:3px 5px;padding:3px;border-bottom:2px solid transparent;display:inline-block}.Tab-82b95533:first-child{margin-left:-3px}.activeTab-f430c37d{font-weight:bold;border-bottom:2px solid #f70}\n", ""]);

// Exports
exports.locals = {
	"TabNav": "TabNav-16a824eb",
	"Tab": "Tab-82b95533",
	"activeTab": "activeTab-f430c37d"
};